import { useEffect } from 'react';
var MIN_HEIGHT = 16;
export default function useStickyBottom(parentRef, footerRef) {
  useEffect(function () {
    var footer = footerRef.current;
    var parent = parentRef.current;
    var handleFocusing = function handleFocusing(e) {
      var target = e.target ? e.target : null;
      if (target && footer && parent && target !== parent) {
        var targetRect = target.getBoundingClientRect();
        var stickyRect = footer.getBoundingClientRect();

        // Custom checkboxes have height == 1
        var bottom = targetRect.height > MIN_HEIGHT ? targetRect.bottom : targetRect.top + MIN_HEIGHT;
        if (bottom > stickyRect.top) {
          var scrollY = stickyRect.height;
          if (typeof parent.scrollBy === 'function') {
            // element.scrollBy isn't supported in IE11 and Edge...
            parent.scrollBy(window.pageXOffset, scrollY);
          } else {
            // if scrollBy isn't supported and it's not window/document, we can use
            // scrollTop adjustment
            // hat tip: https://stackoverflow.com/a/29012684
            parent.scrollTop += scrollY;
          }
        }
      }
    };
    if (parent) {
      parent.addEventListener('focusin', handleFocusing, false);
    }
    return function () {
      if (parent) {
        parent.removeEventListener('focusin', handleFocusing);
      }
    };
  }); // No dependency array need to re-attach every time the drawer re-renders
}